import React from "react";
import "./PnLFloorplansLot.scss";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    rememberFloorplanWindowScrollPosition,
    updateActiveCompareElevation,
    updateActiveCompareFloorplan,
    updateActiveElevation,
    updateActiveFloorplan,
} from "../../redux/actions/floorplanActions";
import {
    updateActiveCompareFloorplanViaID,
    updateActiveFloorplanViaID,
} from "../../redux/actions/floorplanActions.js";

function PnLFloorplansLot(props) {
    var history = useHistory();
    var dispatch = useDispatch();

    function handleClicked(fp, elevation, compare = false, side) {
        //now we should just simply set our active floorplan to whatever floorplan id
        //and elevation we have selected and default to starting on that one when we come in

        if (compare) {
            //we need to change teh compare of the side we are on instead of the main one
            //dispatch(updateActiveCompareFloorplan(fp, side));
            dispatch(updateActiveCompareFloorplanViaID(fp, side));
            dispatch(updateActiveCompareElevation(elevation, side));
        } else {
            //dispatch(updateActiveFloorplan(fp));
            dispatch(updateActiveFloorplanViaID(fp));
            dispatch(updateActiveElevation(elevation));
            dispatch(rememberFloorplanWindowScrollPosition(window.scrollY));
            history.push("/floorplans/details");
        }
    }

    function handlePoppyClicked(fp, elevation, compare = false, side) {
        if (compare) {
            dispatch(updateActiveCompareFloorplanViaID(fp, side));
            dispatch(updateActiveCompareElevation(elevation, side));
        } else {
            dispatch(updateActiveFloorplanViaID(fp));
            dispatch(updateActiveElevation(elevation));
            dispatch(rememberFloorplanWindowScrollPosition(window.scrollY));
            history.push("/multi-flex/poppy");
        }
    }

    function interactiveElevationLetter() {
        //we need to check if we have only 1 elevation. In that case we're going to display the letter along with the Name.
        //other wise we will not display the letter

        var rtn = "";

        if (props.lot.elevation.length < 2) {
            rtn = props.elv.elevation_name;
        }

        return rtn;
    }

    function lotColourClass() {
        var rtn = "";
        if (props.lot.ID == 4289) {
            rtn = " dark-green";
        } else if (props.lot.type[0].name == "36'") {
            rtn = " green";
        } else if (props.lot.type[0].name == "40'") {
            rtn = " orange";
        }

        return rtn;
    }

    function lotName() {
        if (props.lot.ID == 4289) {
            return "Poppy : Two Homes in One";
        } else {
            return props.lot.post_title + " " + interactiveElevationLetter();
        }
    }

    return (
        <button
            className={`PnLFloorplansLot${lotColourClass()}`}
            onClick={() => {
                if (props.lot.ID == 4289) {
                    //handlePoppyClicked(props.lotIndex, props.elvIndex);
                    handlePoppyClicked(
                        props.lot.ID,
                        props.elvIndex,
                        props.compare,
                        props.side
                    );
                } else {
                    handleClicked(
                        //props.lotIndex,
                        props.lot.ID,
                        props.elvIndex,
                        props.compare,
                        props.side
                    );
                }
            }}
        >
            <div className="image-container">
                <img src={props.elv.elevation_image} className="image" />
            </div>
            <h2 className="heading">{lotName()}</h2>
            <div className="elevation_type">{props.lot.type[0].name}</div>
            <div className="stats-container">
                {Object.keys(props.elv.stats).map((key, index) => (
                    <div className="stat">
                        <img src={props.icons[key]} className="icon" />
                        <div className="label">{props.elv.stats[key]}</div>
                    </div>
                ))}
            </div>
        </button>
    );
}

export default PnLFloorplansLot;
